var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 484,
    viewBox: "0 0 343 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.509043 32.9497C0.509035 15.2766 14.8359 0.949708 32.509 0.949707L310.509 0.94972C328.182 0.949722 342.509 15.2766 342.509 32.9497L342.509 448.95C342.509 466.623 328.182 480.95 310.509 480.95L32.509 480.95C14.8359 480.95 0.509029 466.623 0.509028 448.95L0.509043 32.9497Z",
    fill: "url(#paint0_linear_206_291)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.385786 34.3585C0.385778 16.6854 14.7127 2.35854 32.3858 2.35854L310.386 2.35855C328.059 2.35855 342.386 16.6854 342.386 34.3586V450.359C342.386 468.032 328.059 482.359 310.386 482.359H32.3858C14.7127 482.359 0.385772 468.032 0.385771 450.359L0.385786 34.3585Z",
    fill: "url(#paint1_linear_206_291)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.262512 35.7674C0.262512 18.0943 14.5894 3.76738 32.2625 3.76738H310.263C327.936 3.76738 342.263 18.0943 342.263 35.7674V451.767C342.263 469.441 327.936 483.767 310.263 483.767H32.2625C14.5894 483.767 0.262512 469.44 0.262512 451.767V35.7674Z",
    fill: "#0C67FE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_206_291",
    x1: 171.386,
    y1: 0.949707,
    x2: 171.386,
    y2: 483.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_206_291",
    x1: 171.386,
    y1: 0.949707,
    x2: 171.386,
    y2: 483.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLight);
export default __webpack_public_path__ + "static/media/CardLight.727ce0a99d7ec13c877164a189cf0824.svg";
export { ForwardRef as ReactComponent };